import { GLOBAL_NAV_HEIGHT } from '@/styles/theme/constants';
import { makeStyles } from '@/styles/theme/tss-react';

interface Props {
  useTransition: boolean;
}

const useStyles = makeStyles<Props>({
  name: 'SharedNav',
})(({ brandColors, breakpoints, zLevels, typography }, props) => ({
  navContainer: {
    left: 0,
    right: 0,
    background: 'rgba(0,0,0,0)',
    transition: props.useTransition
      ? 'background .25s, color .25s, height .25s, top .5s'
      : '',
    color: brandColors.offWhite,
    zIndex: zLevels.dropdown,
    maxHeight: typography.pxToRem(GLOBAL_NAV_HEIGHT),
  },
  logoContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  navItem: {
    [breakpoints.up('md')]: {
      flexGrow: 1,
      flexShrink: 1,
      flexBasis: 'auto',
    },
  },
  dropdownContainer: {
    [breakpoints.up('md')]: {
      position: 'fixed',
      top: typography.pxToRem(125),
      left: 0,
      right: 0,
      borderBottom: '1px solid var(--Line, rgba(0, 0, 0, 0.20))',
    },
  },
  logoLinkOnLight: {
    fill: brandColors.primaryMain,
    '&:hover, &:focus': {
      fill: brandColors.mediumBlue,
    },
  },
  logoLinkOnDark: {
    fill: brandColors.white,
    '&:hover, &:focus': {
      fill: brandColors.offWhite,
    },
  },
  lightOpaqueContainer: {
    background: brandColors.tintsOffWhite60,
  },
  darkOpaqueContainer: {
    background: brandColors.tintsHeroBlue10,
  },
  // Full-bleed fade behind the main nav row. The utility bar stays solid.
  immersiveMainGradient: {
    background: `linear-gradient(180deg, ${brandColors.tintsHeroBlue10} 0%, transparent 100%)`,
  },
  onDarkText: {
    color: brandColors.white,
  },
  onLightText: {
    color: brandColors.black,
  },
  navBody: {
    display: 'flex',
    position: 'relative',
    padding: `${typography.pxToRem(16)} 0`,
    [breakpoints.up('md')]: {
      padding: 0,
    },
    justifyContent: 'space-between',
    alignItems: 'center',
    alignSelf: 'stretch',
    zIndex: zLevels.dropdown,
  },
  placeholder: {
    height: typography.pxToRem(GLOBAL_NAV_HEIGHT),
    width: '100%',
  },
  helperNavContainer: {
    borderBottom: '1px solid var(--Line, rgba(0, 0, 0, 0.20))',
  },
}));

export default useStyles;
